export default __webpack_public_path__ + "static/media/img-gtl-du3@3x.02010d61.png";